import type { World } from "../sim/types";
import type { Renderer } from "./renderer";

/** Bit 4 = plume ray (tiles.wgsl capsule SDF path). */
const FLAG_PLUME_RAY = 4;

/** alongStart/alongEnd reuse tempK/damageFrac slots. */
export function pushPlumeTiles(r: Renderer, world: World): void {
  const uv = r.atlas.lookup.get("plume_ray");
  if (!uv) return;
  for (const seg of world.plumeSegments) {
    r.pushPlumeRaw(
      seg.cx, seg.cy,
      seg.len, seg.width,
      seg.rot, FLAG_PLUME_RAY,
      uv.u, uv.v, uv.w, uv.h,
      seg.alongStart, seg.alongEnd,
    );
  }
}
